module.exports = __webpack_public_path__ + "img/216-Schoco SAF-RAL 9006 semigloss.png";